import { Overrides } from '@material-ui/core/styles/overrides'

import { fonts } from './fonts'

const helperTextOverride: Overrides = {
  MuiFormHelperText: {
    root: {
      fontSize: fonts.size.xsmall,
      fontWeight: 'normal',
    },
  },
}

export default helperTextOverride
